import styles from './circleStyleTextBox.module.css';

const CircleStyleTextBox = ({ children,className }) => {
  return (
    <div className={`${styles.box} ${className}`}>
      {/* <svg
        width="130"
        height="130"
        viewBox="0 0 130 130"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.circle}
      >
        <circle
          cx="65"
          cy="65"
          r="64"
          stroke="url(#paint0_linear_1749_43255)"
          stroke-width="2"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1749_43255"
            x1="65"
            y1="1"
            x2="65"
            y2="129"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#90BAD5" stop-opacity="0.3" />
            <stop offset="1" stop-color="#90BAD5" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg> */}

      {children}
    </div>
  );
};

export default CircleStyleTextBox;
